import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../../services/api';

function MeiosSaidaFormPage() {
  const [nome, setNome] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const navigate = useNavigate();
  const { id } = useParams();

  const pageTitle = id ? 'Editar Meio de Saída' : 'Novo Meio de Saída';
  const pageSubtitle = id ? `Editando o registro #${id}` : 'Preencha os dados para criar um novo meio de saída';

  // Busca os dados do meio de saída para edição
  useEffect(() => {
    if (id) {
      setLoading(true);
      api.get(`/meios-saida/${id}`)
        .then(response => {
          const { nome } = response.data.data;
          setNome(nome);
        })
        .catch(err => {
          setError('Não foi possível carregar os dados do meio de saída.');
          console.error(err);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [id]);

  // Envia os dados do formulário (criação ou atualização)
  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError(null);

    const meioSaidaData = { nome };

    try {
      if (id) {
        await api.put(`/meios-saida/${id}`, meioSaidaData);
      } else {
        await api.post('/meios-saida', meioSaidaData);
      }
      navigate('/painel/meios-saida');
    } catch (err) {
      if (err.response && err.response.data && err.response.data.message) {
        setError(err.response.data.message);
      } else {
        setError('Ocorreu um erro ao salvar o meio de saída. Verifique os dados.');
      }
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (loading && id) {
    return (
      <div className="meios-saida-form-page">
        <p>Carregando dados do meio de saída...</p>
      </div>
    );
  }

  return (
    <div className="meios-saida-form-page">
      <div className="content-header">
        <h1 className="content-title">{pageTitle}</h1>
        <p className="content-subtitle">{pageSubtitle}</p>
      </div>

      <div className="card meios-saida-form-card">
        <div className="card-body">
          <form className="meios-saida-form" onSubmit={handleSubmit}>
            {error && <div className="alert alert-danger">{error}</div>}

            <div className="mb-3">
              <label htmlFor="nome" className="form-label">Nome</label>
              <input
                type="text"
                className="form-control"
                id="nome"
                value={nome}
                onChange={(e) => setNome(e.target.value)}
                required
              />
            </div>

            <div className="meios-saida-form-actions d-flex justify-content-end">
              <button
                type="button"
                className="btn btn-secondary me-2"
                onClick={() => navigate('/painel/meios-saida')}
                disabled={loading}
              >
                Cancelar
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading}
              >
                {loading ? 'Salvando...' : 'Salvar'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default MeiosSaidaFormPage;
